export const APP_LANGUAGES = ["en", "fr"] as const;
export type AppLanguage = (typeof APP_LANGUAGES)[number];

export const DEFAULT_APP_LANGUAGAE: AppLanguage = "en";
